import axios from "axios";
import jwt_decode from "jwt-decode";

import { logout } from "../components/app-header/UserProfile/UserProfile.utils";
import fetchEnv from "./FetchEnv";
import TenantExtractor from "./TenantExtracter";

let cachedRuntimeConfig = null;

export const fetchRuntimeConfig = async () => {
  // Return the cached config if it exists
  if (cachedRuntimeConfig) return cachedRuntimeConfig;

  const loginResponseRaw = localStorage.getItem("loginResponse");
  if (!loginResponseRaw) {
    throw new Error("Missing loginResponse in localStorage");
  }

  const loginResponse = JSON.parse(loginResponseRaw);
  const jwtToken = loginResponse?.object?.jwt;
  if (!jwtToken) throw new Error("JWT token missing");

  try {
    const userID = loginResponse.object.username;
    const tenantId = localStorage.getItem("tenantId");
    const tenantUUID = jwt_decode(jwtToken).tenantUUID;
    const userRoles = jwt_decode(jwtToken).userRoles?.join(",") ?? "";
    const product = TenantExtractor.getProduct();
    const apiKey = fetchEnv()?.REACT_APP_AUTH_SUBSCRIPTION_KEY;

    const response = await axios.get(`${fetchEnv()?.REACT_APP_APIURL_CASE}/caseManagement/api/react-config`, {
      headers: {
        Authorization: jwtToken,
        "Accept-Language": "en",
        "Ocp-Apim-Subscription-Key": apiKey,
        tenantID: tenantId,
        tenantUUID,
        userID,
        userRoles,
        product,
      },
    });

    cachedRuntimeConfig = response.data;
    return cachedRuntimeConfig;
  } catch (error) {
    if (error.response?.status === 401) logout();
    throw error;
  }
};
